import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shop-version",
  "use": "icon-shop-version-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shop-version\"><path d=\"M170.667 128h682.666c23.467 0 42.667 19.2 42.667 42.667v682.666c0 23.467-19.2 42.667-42.667 42.667H170.667c-23.467 0-42.667-19.2-42.667-42.667V170.667c0-23.467 19.2-42.667 42.667-42.667zm0 85.333v597.334h682.666V213.333H170.667zm128 128h426.666v42.666H298.667v-42.666zm0 128h426.666v42.666H298.667v-42.666zm0 128h298.666v42.667H298.667v-42.667zM640 384l170.667 128L640 640V384z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shop-version.svg
// module id = emzE
// module chunks = 29